export default {"src":"/hedera/_next/static/media/lineDark.bfbd71f2.svg","height":2,"width":24};